module.exports = __webpack_public_path__ + "static/img/9.bc6d014.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/9.png
// module id = +9Yy
// module chunks = 0